export default function AppUrlListener() {
    return null;
}